<div class="login-page">
  <div
    class="login-banner justify-content-center align-items-center login-container"
    [style.background-image]="'url(' + ('login-registration/login-page-banner.jpg' | contentAssetImage) + ')'"
  >
    <img [src]="'login-registration/login-br-logo.png' | contentAssetImage" alt="logo" height="182" class="mb-5 logo" />
    <div class="login-header">
      <div class="login-header-title text-center">
        {{ 'login.header.title' | translate }}
      </div>
      <div class="login-header-description">
        {{ 'login.header.description' | translate }}
      </div>
      <div class="login-header-btn">
        <fgb-sports-alliance-user-login></fgb-sports-alliance-user-login>
      </div>
    </div>
  </div>
  <div class="bg-muted pt-lg-4">
    <div class="container login-earn-points mb-30 px-lg-0 px-3">
      <div class="login-earn-points-title">
        <span class="text">{{ 'login.earn.points.title' | translate }}</span>
      </div>
      <div class="border-right-rounded">
        <div
          class="login-earn-points-description"
          [innerHTML]="'login.earn.points.description' | translate | markdownTranslate"
        ></div>
        <div class="login-earn-points-icon-blocks d-flex flex-lg-row flex-column gap-3 my-5">
          <div class="icon-block w-100">
            <div class="w-100 text-lg-center d-flex flex-row flex-lg-column">
              <div class="img me-lg-0 mb-lg-3 me-4">
                <img [src]="'login-registration/prizedraws.svg' | contentAssetImage" width="58" alt="attend" />
              </div>
              <div class="text">
                <div class="title">{{ 'login.earn.points.icon.block.title.attend' | translate }}</div>
                <div class="description">{{ 'login.earn.points.icon.block.description.attend' | translate }}</div>
              </div>
            </div>
          </div>
          <div class="icon-block w-100">
            <div class="w-100 text-lg-center d-flex flex-row flex-lg-column">
              <div class="img me-lg-0 mb-lg-3 me-4">
                <img [src]="'login-registration/extension.svg' | contentAssetImage" width="58" alt="engage" />
              </div>
              <div class="text">
                <div class="title">{{ 'login.earn.points.icon.block.title.engage' | translate }}</div>
                <div class="description">{{ 'login.earn.points.icon.block.description.engage' | translate }}</div>
              </div>
            </div>
          </div>
          <div class="icon-block w-100">
            <div class="w-100 text-lg-center d-flex flex-row flex-lg-column">
              <div class="img me-lg-0 mb-lg-3 me-4">
                <img [src]="'login-registration/pound.svg' | contentAssetImage" width="58" alt="spend" />
              </div>
              <div class="text">
                <div class="title">{{ 'login.earn.points.icon.block.title.spend' | translate }}</div>
                <div class="description">{{ 'login.earn.points.icon.block.description.spend' | translate }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container login-redeem pb-1 px-lg-0 px-3">
      <div class="login-redeem-title">
        <span class="text text-center">{{ 'login.redeem.title' | translate }}</span>
      </div>
      <div class="border-right-rounded">
        <div class="login-redeem-description">
          {{ 'login.redeem.description' | translate }}
        </div>
        <div class="login-redeem-icon-blocks d-flex flex-lg-row flex-column gap-3 my-5">
          <div class="icon-block w-100">
            <div class="w-100 text-lg-center d-flex flex-row flex-lg-column">
              <div class="img me-lg-0 mb-lg-3 me-4">
                <img [src]="'login-registration/experiences.svg' | contentAssetImage" width="68" alt="experiences" />
              </div>
              <div class="text">
                <div class="title">{{ 'login.redeem.icon.block.title.experiences' | translate }}</div>
                <div class="description">{{ 'login.redeem.icon.block.description.experiences' | translate }}</div>
              </div>
            </div>
          </div>
          <div class="icon-block w-100">
            <div class="w-100 text-lg-center d-flex flex-row flex-lg-column">
              <div class="img me-lg-0 mb-lg-3 me-4">
                <img [src]="'login-registration/prizedraws.svg' | contentAssetImage" width="68" alt="prize-draws" />
              </div>
              <div class="text">
                <div class="title">{{ 'login.redeem.icon.block.title.prize.draws' | translate }}</div>
                <div class="description">{{ 'login.redeem.icon.block.description.prize.draws' | translate }}</div>
              </div>
            </div>
          </div>
          <div class="icon-block w-100">
            <div class="w-100 text-lg-center d-flex flex-row flex-lg-column">
              <div class="img me-lg-0 mb-lg-3 me-4">
                <img [src]="'login-registration/memorabilia.svg' | contentAssetImage" width="68" alt="memorabilia" />
              </div>
              <div class="text">
                <div class="title">{{ 'login.redeem.icon.block.title.memorabilia' | translate }}</div>
                <div class="description">{{ 'login.redeem.icon.block.description.memorabilia' | translate }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="login-banner"
    [style.background-image]="'url(' + ('login-registration/login-background.png' | contentAssetImage) + ')'"
  >
    <div class="container login-join-us mb-40 pt-lg-4 text-white">
      <div class="login-join-us-title text-center">
        <span class="material-symbols-outlined fill"> credit_card </span>
        <div class="text default-font">{{ 'login.join.us.title' | translate }}</div>
      </div>
      <div class="login-join-us-description text-center mb-40">
        {{ 'login.join.us.description' | translate }}
      </div>
      <div class="login-join-us-images row align-items-center">
        <div class="col-12 col-lg-4">
          <a href="{{ 'login.half.season.link' | translate }}" target="_blank" rel="noopener noreferrer">
            <img class="w-100" [src]="'login-registration/bluebirds-uncaged.png' | contentAssetImage" height="172" />
          </a>
        </div>
        <div class="col-12 col-lg-4">
          <a href="{{ 'membership.link' | translate }}" target="_blank" rel="noopener noreferrer">
            <img class="w-100" [src]="'login-registration/club-membership.png' | contentAssetImage" height="172" />
          </a>
        </div>
        <div class="col-12 col-lg-4">
          <a href="{{ 'kids.membership.link' | translate }}" target="_blank" rel="noopener noreferrer">
            <img class="w-100" [src]="'login-registration/junior-membership.png' | contentAssetImage" height="172" />
          </a>
        </div>
        <div class="br"></div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="login-how-to-buy col-12 col-lg-4 mb-lg-0 mb-4">
          <div class="login-how-to-buy-title">{{ 'login.how.to.buy.title' | translate }}</div>
          <div class="login-how-to-buy-ways d-flex m-0">
            <div class="buy-online">
              <img [src]="'login-registration/buy-online.png' | contentAssetImage" width="103" alt="buy-oneline" />
              <a href="{{ 'login.buy.tickets.link' | translate }}" target="_blank" rel="noopener noreferrer">
                <button class="btn btn-primary">{{ 'login.buy.oneline.btn' | translate }}</button>
              </a>
            </div>
            <div class="buy-phone">
              <img [src]="'login-registration/phone.png' | contentAssetImage" width="70" alt="phone" />
              <div class="text mt-3">
                {{ 'login.buy.phone' | translate }}
              </div>
              <div class="text mt-1">
                {{ 'login.buy.phone.number' | translate }}
              </div>
            </div>
          </div>
        </div>
        <div class="container login-help col-12 col-lg-8">
          <div class="login-help-title mb-2">{{ 'login.help.title' | translate }}</div>
          <div class="login-help-subtitle">{{ 'login.help.subtitle' | translate }}</div>
          <div class="login-help-links">
            <div class="link">
              <span class="email fw-bold"> {{ 'login.help.rewards.link' | translate }}</span>
              <span class="d-inline-block mx-1"> - </span>
              <span>{{ 'login.help.rewards.description' | translate }}</span>
            </div>
            <div class="link">
              <span class="email fw-bold"> {{ 'login.help.tickets.link' | translate }}</span>
              <span class="d-inline-block mx-1"> - </span>
              <span>{{ 'login.help.tickets.description' | translate }}</span>
            </div>
            <div class="link">
              <span class="email fw-bold"> {{ 'login.help.sales.link' | translate }}</span>
              <span class="d-inline-block mx-1"> - </span>
              <span>{{ 'login.help.sales.description' | translate }}</span>
            </div>
            <div class="link">
              <span class="email fw-bold"> {{ 'login.help.questies.link' | translate }}</span>
              <span class="d-inline-block mx-1"> - </span>
              <span>{{ 'login.help.questies.description' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
